<template>
  <div class="lundao-dashboard" v-loading="loading">
    <!-- 标题区域 -->
    <div class="dashboard-header">
      <h2 class="dashboard-title">数据统计看板</h2>
      <div class="filter-section">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="handleDateChange"
          class="date-picker"
        />
      </div>
    </div>

    <!-- 数据指标卡片 -->
    <div class="metrics-grid">
      <el-card
        v-for="(metric, index) in metrics"
        :key="index"
        class="metric-card"
        :class="{ 'highlight': metric.highlight }"
        shadow="hover"
      >
        <div class="metric-content">
          <div class="metric-header">
            <div class="metric-icon">
              <i :class="metric.icon"></i>
            </div>
            <div class="metric-title">{{ metric.label }}</div>
          </div>
          <div class="metric-value">{{ metric.value }}</div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import util from '../../../libs/util'

export default {
  name: 'lundao-dashboard',
  data() {
    return {
      dateRange: [],
      loading: false,
      metrics: [
        {
          label: '活跃用户数',
          value: 0,
          icon: 'el-icon-s-custom',
          highlight: true,
          key: 'activeUserCount'
        },
        {
          label: '邀请成功人数',
          value: 0,
          icon: 'el-icon-connection',
          key: 'inviteSuccessCount',
          highlight: true
        },
        {
          label: '生成大纲数',
          value: 0,
          icon: 'el-icon-notebook-2',
          key: 'outlineGenerateCount',
          highlight: true
        },
        {
          label: '订单数',
          value: 0,
          icon: 'el-icon-shopping-bag-1',
          key: 'orderCount',
          highlight: true
        },
        {
          label: '累计下单金额(元)',
          value: '0.00',
          icon: 'el-icon-coin',
          highlight: true,
          key: 'totalOrderAmount'
        },
        {
          label: '累计返现金额(元)',
          value: '0.00',
          icon: 'el-icon-money',
          key: 'totalCashbackAmount',
          highlight: true
        },
        {
          label: '净收入(元)',
          value: '0.00',
          icon: 'el-icon-wallet',
          highlight: true,
          key: 'netIncome'
        }
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    async handleDateChange() {
      if (!this.dateRange || this.dateRange.length !== 2) return

      try {
        await this.fetchDashboardData()
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$notify.error({
          title: '错误',
          message: '获取数据失败'
        })
      }
    },

    async fetchDashboardData() {
      this.loading = true
      try {
        const res = await util.ajax.get('/entity/dev/paperDashboard/data', {
          params: {
            startDate: this.formatDate(this.dateRange[0]),
            endDate: this.formatDate(this.dateRange[1])
          }
        })

        if (res.data.meta.errCode === 0) {
          this.updateMetrics(res.data.data)
        } else {
          this.$notify.error({
            title: '错误',
            message: res.data.meta.errMsg
          })
        }
      } catch (err) {
        this.$notify.error({
          title: '错误',
          message: '获取数据失败'
        })
        console.error(err)
      } finally {
        this.loading = false
      }
    },

    updateMetrics(data) {
      this.metrics.forEach(metric => {
        if (data[metric.key] !== undefined) {
          // 对金额类数据进行格式化
          if (['totalOrderAmount', 'totalCashbackAmount', 'netIncome'].includes(metric.key)) {
            metric.value = Number(data[metric.key]).toFixed(2)
          } else {
            metric.value = data[metric.key]
          }
        }
      })
    },

    formatDate(date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  },
  mounted() {
    // 组件加载时设置默认时间范围为最近7天
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    this.dateRange = [start, end]
    this.handleDateChange()
  }
}
</script>

<style scoped>
.lundao-dashboard {
  padding: 24px;
  background: #f5f7fa;
  min-height: 100vh;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: #ffffff;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dashboard-title {
  margin: 0;
  color: #303133;
  font-size: 20px;
  font-weight: 600;
}

.date-picker {
  width: 400px;
  border-radius: 8px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.metric-card {
  border-radius: 8px;
  transition: all 0.3s ease;
  background: #ffffff;
  border: 1px solid #ebeef5;
}

.metric-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.metric-content {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.metric-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.metric-icon {
  font-size: 20px;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background: linear-gradient(135deg, #e6f3ff 0%, #f2f6fc 100%);
  color: #409EFF;
  transition: all 0.3s ease;
}

.metric-card:hover .metric-icon {
  background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
  color: white;
  transform: scale(1.05);
}

.metric-card.highlight .metric-icon {
  background: linear-gradient(135deg, #409EFF 0%, #1890ff 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
}

.metric-title {
  font-size: 15px;
  color: #606266;
  font-weight: 500;
}

.metric-value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
  margin-top: 4px;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .date-picker {
    width: 100%;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
  }
}

/* 添加loading样式 */
.lundao-dashboard {
  position: relative;
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/custom/components/paper/lundao-dashboard.vue